var map = {
	"./atlaslogistics/slingco/logo.png": 7938,
	"./kranlee/AMBLIMIT/logo.png": 3989,
	"./kranlee/FORB0001/logo.png": 9595,
	"./kranlee/FORBOFLO/logo.png": 1067,
	"./kranlee/NORTHERN/logo.png": 6355,
	"./kranlee/ROBERLIM/logo.png": 9307,
	"./kranlee/SCHENCKP/logo.png": 2297,
	"./kranlee/SPEEDPLA/logo.png": 1884,
	"./kranlee/TAYLORSE/logo.png": 2579,
	"./kranlee/TTSPRECI/logo.png": 7825,
	"./kranlee/intocast/logo.png": 4607,
	"./kranlee/shculcem/logo.png": 5492,
	"./kranlee/unipartr/logo.png": 8553,
	"./webtest/andysana/logo.png": 1794
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1378;